export const ACTION_RESET = 'FETCH_WIDGETARTICLELIST_RESET';
export const ACTION_REQUEST = 'FETCH_WIDGETARTICLELIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_WIDGETARTICLELIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_WIDGETARTICLELIST_ERROR';
